export default {
  title: "Menejerlar",
  newPassRules1: "Kamida 8 ta belgidan iborat bo‘lishi kerak",
  appearAfterCreateManager:
    "Bu yerda menejer yaratilgandan so‘ng paydo bo‘ladi",
  canCreateManagerAfterConfirmEntity:
    "Menejer yaratish imkoniyati sizning yuridik shaxsingiz moderatsiyadan o‘tgach mavjud bo‘ladi",
  managerPassReset: "Menejerning paroli tiklandi",
  writeDownLoginAndPass:
    "Diqqat! Kirish uchun login va parolni yozib oling. Birinchi kirishda menejer yangi parol yaratishi kerak bo‘ladi.",
  oneTimePass: "Bir martalik parol",
  loginAndPassCopied: "Login va parol buferga nusxalandi",
  managerCreated: "Menejer yaratildi!",
  copyLoginAndPass: "Login va parolni nusxalash",
  sureToDeleteManager: "Menejerni o‘chirib tashlamoqchimisiz?",
  editingManager: "Menejerni tahrirlash",
  creatingManager: "Menejer yaratish",
  resetPassword: "Parolni tiklash",
  workPost: "Lavozim",
  accessToCabinetPages: "Kabinet sahifalariga kirish huquqi",
  deleteChanges: "Kiritilgan o‘zgarishlarni o‘chirilsinmi?",
  cancelManagerCreating: "Menejer yaratishni bekor qilasizmi?",
  ifNeedSaveGoBack:
    "Agar saqlamoqchi bo‘lsangiz, orqaga qayting. Aks holda barcha o‘zgarishlar saqlanmaydi.",
  enteredInfoDontSave:
    "Kiritilgan ma’lumotlar saqlanmaydi. Tahrirlashga qaytish uchun «Orqaga» tugmasini bosing.",
  notLess8Chars: "Kamida 8 ta belgi",
  requiredField: "Majburiy maydon",
};
